import {
  APP_URL,
  APP_URL_CONTRACT,
  COMPANY,
  CONTRACT,
  CONTRACTRENEW,
  CONTRACTTYPEFORMATE,
  CONTRACTTYPEACTIVE,
  MAESTRAS,
  PERSONBYDOCUMENTANDTYPEAUTH,
} from "../constants";
import HttpClient from "../services/HttpClient";

export const getCompany = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    //HttpClient.get(`http://contract-dot-sae-dev.ue.r.appspot.com/company-data`, headers).then(response =>{
    HttpClient.get(`${APP_URL_CONTRACT}${COMPANY}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {
          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getMaestras = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${MAESTRAS}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {
          //
          resolve(error.response);
          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        resolve(error.response);
        reject(error.response);
      });
  });
};

export const getContractType = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPEFORMATE}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {
          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getContractTypeForGenerate = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPEACTIVE}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {
          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getContractPerson = (document, type) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL}${PERSONBYDOCUMENTANDTYPEAUTH}?document=${document}&type=${type}`,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {
          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const saveContract = (data) => {
  return new Promise((resolve, reject) => {
    const config = { responseType: "blob" };

    HttpClient.post(`${APP_URL_CONTRACT}${CONTRACT}`, data, config)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

export const contractById = (idContract) => {
  const headers = { "Content-Type": "application/json" };
  return new Promise((resolve) => {
    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACT}/${idContract}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};

export const renewContract = (idContract, body) => {
  return new Promise((resolve, reject) => {
    const config = { responseType: "blob" };
    HttpClient.post(
      `${APP_URL_CONTRACT}${CONTRACTRENEW}${idContract}`,
      body,
      config
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error?.response);
      });
  });
};
